export default "__VITE_ASSET__Cn35MIaa__"